<template>
  <div v-if="estimation && estimation.services.length > 0">
    <table 
      class="table has-smallest-font mt-3 mb-2"
      :class="{ 'is-fullwidth': isFullwidth }">
      <thead>
        <tr class="has-text-centered">
          <th
            :class="header.class"
            v-for="(header, i) in headers"
            :key="i">
            {{ header.label | uppercase }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr 
          class="pricing__service"
          v-for="(service, serviceIndex) in estimation.services"
          :key="service.id">
          <td 
            class="border--after"
            v-if="serviceIndex == 0"
            :rowspan="estimation.services.length">
            Services
          </td>
          <td class="border--after">
            {{ service.service.service_name }}
          </td>
          <td>
            {{ service.area | commasep(0) }}
          </td>
          <td class="border--after">
            {{ service.service.unit.unit_display_name }}
          </td>
          <td>
            {{ service.price | currency(0) }}
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr class="pricing__total">
          <td 
            colspan="4" 
            class="has-text-weight-bold border--after">
            TOTAL
          </td>
          <td>
            {{ estimation.total_service_price | currency(1) }}
          </td>
        </tr>
        <tr class="pricing__total">
          <td 
            colspan="4" 
            class="has-text-weight-bold border--after">
            HST
          </td>
          <td>
            {{ estimation.total_service_price * estimation.tax_pct | currency(1) }}
          </td>
        </tr>
        <tr class="pricing__grand-total">
          <td 
            colspan="4" 
            class="has-text-weight-bold border--after">
            TOTAL INCLUDING HST
          </td>
          <td>
            {{ estimation.total_service_price * (1 + (+estimation.tax_pct)) | currency(1) }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    estimation: {
      type: Object
    },
    isFullwidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { label: 'Item', class: 'pricing__item' },
        { label: 'Description', class: 'pricing__service' },
        { label: 'Area', class: 'pricing__service' },
        { label: 'Unit', class: 'pricing__service border--after' },
        { label: 'Cost', class: 'pricing__service' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/detailed-pricing-cladify.scss';
</style>